/* Batch 32 · T7 — Document Review takes PDF and images only: the same list the server accepts on /documents/upload
 * (server.py MIME_MAP: pdf, png, jpg, jpeg, webp). A dropped spreadsheet (or any other file) is not sent; the page names how
 * many were left out and where client schedules go (Head folders → the head's lead sheet / worksheet attachments, which take
 * .csv / .xlsx / .xls). */
export const DOC_REVIEW_EXTS = ["pdf", "png", "jpg", "jpeg", "webp"];
export const DOC_REVIEW_ACCEPT = DOC_REVIEW_EXTS.map((e) => `.${e}`).join(",");

const extOf = (name) => {
  const m = /\.([^.]+)$/.exec(String(name || ""));
  return m ? m[1].toLowerCase() : "";
};

/** { accepted: File[], rejected: File[] } — by file-name extension, as the server checks it. */
export function splitDocReviewFiles(files) {
  const accepted = [];
  const rejected = [];
  for (const f of files || []) (DOC_REVIEW_EXTS.includes(extOf(f && f.name)) ? accepted : rejected).push(f);
  return { accepted, rejected };
}
